import { APP_SECTIONS } from 'modules/search/constants/index.js'

export function isAppSectionUtil (section) {
  return APP_SECTIONS.includes(section)
}
